import { Spin } from 'antd';
import { fetchAuthSession } from 'aws-amplify/auth';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { APP_ROUTES, REACT_APP_HOSPITAL_CODE } from 'src/enums';
import { ApiService } from 'src/services';
import {
  useDispatch,
  userActions,
  userSelectors,
  useSelector
} from 'src/store';
import { getErrorMessage } from 'src/utils';

import classes from './style/auth.module.css';

interface IPublicPageProps {
  children: any;
}

export const PublicPage: React.FunctionComponent<IPublicPageProps> = (
  props
) => {
  // TOOLS
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // STATE
  const [authState, setAuthState] = React.useState<{
    loader: boolean;
    error: null | string;
  }>({ loader: false, error: null });
  const [mounted, setMount] = React.useState(false);

  // SELECTORS
  const user = useSelector(userSelectors.selectUser);

  const getCurrentSession = async () => {
    try {
      setAuthState({ loader: true, error: null });
      const authSession = await fetchAuthSession();
      const { idToken, accessToken } = authSession?.tokens || {};
      console.log('public');
      if (idToken) {
        ApiService.setAuthorization(idToken);
      }

      if (!REACT_APP_HOSPITAL_CODE) {
        console.log('error in public page: HOSPITAL_CODE_NOT_FOUND');
        return;
      }
      // ************************* get user from namer *************************
      const res = await ApiService.getPatientDetailes({
        DeviceId: 'deviceId',
        Token: 'deviceToken',
        IsPatient: true
      });

      const { data } = res;
      if (data.group?.error) {
        console.log('error in getPatientDetailes==>1', data);
        throw new Error(data.group?.error);
      }
      if (data.ErrorCode) {
        console.log('error in getPatientDetailes==>2', data);
        throw new Error(data.ErrorCode);
      }
      const user = res.data;
      // ******** if patient set true, if acompany sel false, we need that to the logout function
      dispatch(
        userActions.setIsPatient({
          value: true
        })
      );
      // ******** set the user - when there is user - the stack going to change!!!
      dispatch(
        userActions.setUser({
          value: user
        })
      );
      setMount(true);
      setAuthState({ loader: false, error: null });
    } catch (error) {
      setMount(true);
      setAuthState({ loader: false, error: getErrorMessage(error) });
    }
  };

  React.useEffect(() => {
    getCurrentSession();
  }, []);

  if (authState.loader) {
    return (
      <div className={classes.loadingPage}>
        <img
          width={150}
          src="assets/Israeli_Ministry_of_Health_logo_big.png"
          alt={t('accessibility.ministryOfHealthLogo')}
          title={t('accessibility.ministryOfHealthLogo')}
        />
        <Spin />
      </div>
    );
  }
  if (mounted) {
    if (user) {
      return <Navigate to={`${APP_ROUTES.HOME}`} />;
    } else {
      return props.children;
    }
  }
};
